module.exports = __webpack_public_path__ + "img/deols.952c54e1.jpg";